export default __webpack_public_path__ + "static/cutsecond-298670d466c1cc7e626fa518989f6d15.png";